
import { Component, Vue, Watch } from "vue-property-decorator";
import { WhatsNew } from "@/views/WhatsNew.vue";
import { _onRegistrationDispatcher, wb } from "./registerServiceWorker";
import { EventHandler } from "./event";
import { createClient } from "@/helpers/graphql-ws-rtc-adapter";
import * as moment from "moment";
import { initRtc } from "./main";
import HelpBot from "@/components/HelpBot.vue";
import { pauseJobsService } from "@/helpers/pause-jobs";

const Subscriber = require("@jetblack/graphql-reconnect-client");

@Component({
  components: { WhatsNew, HelpBot },
})
export default class App extends Vue {
  messages = [];
  name: string = "App";
  navigationDrawer: boolean = false;
  activeNotices: any[] = [];
  timenow: number = Date.now();

  beforeCreate() {
    this.$store.commit("snackbarHide");
    this.$store.commit("popup/hide");
  }
  get moment() {
    return this.$store.state.moment;
  }

  get pauseButtonState() {
    return pauseJobsService.state.pauseButtonState;
  }

  get pauseTimeoutDialogVisible() {
    return pauseJobsService.state.pauseTimeoutDialogVisible;
  }

  get pauseStatus() {
    return pauseJobsService.state.pauseStatus;
  }

  get isPaused() {
    return this.pauseStatus === "Paused";
  }

  get isLoginRoute() {
    return this.$route.name === "login";
  }

  get locationGuid() {
    return (this.$store.state as any).user?.location?.guid as string | undefined;
  }

  @Watch("locationGuid", { immediate: true })
  async onLocationGuidChanged() {
    await pauseJobsService.getPauseStatus();
  }

  handle: EventHandler<ServiceWorkerRegistration> = (registration: ServiceWorkerRegistration) => {
    if (wb) {
      console.log("Workbox...");
      wb.addEventListener("waiting", async () => {
        console.log("Update is ready, waiting");
        this.$store.commit("popup/displayYesNo", {
          message: "An update is available. Would you like to update?",
          yesAction: async () => {
            if (wb) {
              await wb.messageSW({ type: "SKIP_WAITING" });
              window.location.reload();
            } else throw Error("No wb to messageSW SKIP_WAITING");
          },
        });
      });
    } else console.log("NO WORKBOX!");
  };

  async created() {
    console.log("App started...", status);
    _onRegistrationDispatcher.register(this.handle);
  }

  mounted() {
    setInterval(() => {
      this.timenow = Date.now();
    }, 1000);

    this.$vuetify.theme.dark = this.$store.getters["dark"]();
    this.$store.dispatch(
      "user/addFirebaseCallback",
      setTimeout(() => {
        this.getNotificationsSocket();
        //  initRtc();
      }, 5000)
    );
  }

  toggleLightDarkMode() {
    this.$store.commit("lightDarkMode", this.$store.state.lightDarkMode === "light" ? "dark" : "light");
    this.$vuetify.theme.dark = this.$store.getters["dark"]();
  }

  async continuePausing() {
    const result = await pauseJobsService.continuePausing();
    if (!result) return;

    this.$store.commit("snackbar", { message: result.snackText });
  }

  async stopPausingFromDialog() {
    const result = await pauseJobsService.stopPausingFromDialog();
    if (!result) return;

    this.$store.commit("snackbar", { message: result.snackText });
  }

  destroyed() {
    if (this.graphQLUnsubscribe) {
      this.graphQLUnsubscribe();
    }
    if (this.graphQLSubscriber) {
      this.graphQLSubscriber();
    }
  }
  signOut() {
    this.$store.dispatch("user/signOut");
  }
  dialog = false;
  items = [
    { title: "Crib Scores", icon: "mdi-altimeter", link: "crib" },
    { title: "Feed Planning", icon: "mdi-table-large", link: "plan" },
    { title: "Mix Schedule", icon: "mdi-table", link: "mix" },
    { title: "Feeding Schedule", icon: "mdi-nutrition", link: "schedule" },
    { title: "History", icon: "mdi-history", link: "history" },
    { title: "Line Feeding", icon: "mdi-view-list", link: "linefeeding" },
    { title: "Kraal Board", icon: "mdi-view-dashboard", link: "kraalboard" }, ///
    { title: "Animal Movements", icon: "mdi-cow", link: "move" }, ///
    { title: "Feed Delivery", icon: "mdi-tractor", link: "delivery" },
    { title: "Map", icon: "mdi-map", link: "map" },
    { title: "Farm Setup", icon: "mdi-barn", link: "setup" },
    { title: "Options", icon: "mdi-cogs", link: "options" },
    { title: "Notifications", icon: "mdi-message", link: "notifications" },
    { title: "Notes", icon: "mdi-note-text-outline", link: "notes" },
    // { title: "Replay", icon: "mdi-file-chart", link: "reports" },
  ];

  subscriptions = `subscription($guid: String!, $user: String!) {
         activeNotifications(guid: $guid, user:$user) {
          typename
          guid
          userId
          notifiedCount
          message
          conditions{
            typename
            guid
            fieldType
            fieldGuid
            condition
          }
        }
    }`;

  graphQLSubscriber: any = undefined;
  graphQLUnsubscribe: any = undefined;

  async getNotificationsSocket() {
    if (this.$store.state.useP2PConn) {
      await this.getOnlineNotificationsSocket();
    } else {
      await this.getOnSiteNotificationsSocket();
    }
  }

  async getOnlineNotificationsSocket() {
    let variables = { guid: this.$store.state.user.location.guid, user: this.$store.state.user.user.uid };

    const subscribe = (subscriptions: string, variables: any, callback: (error: any, data: any) => Promise<void>) => {
      const client = createClient();
      let unsubscribe = client?.subscribe(
        {
          query: subscriptions,
          variables: variables,
        },
        {
          next: (message: any) => callback(undefined, message.data),
          error: (err: any) => {
            throw err;
          },
          complete: () => console.log("subscription completed"),
        }
      );
      return unsubscribe;
    };

    this.graphQLUnsubscribe = subscribe(this.subscriptions, variables, async (error: any, data: any) => {
      this.$store.state.wsConnected = true;
      if (!(error || subscribe)) {
        console.log("subscribe success");
        this.$store.state.wsDialogVisible = false;
        // Normal closure
        return;
      }
      if (error) {
        console.log("error subscribing");

        this.$store.state.wsConnected = false;
        if (error.event.type === "close") {
        } else {
          this.$store.state.wsDialogVisible = true;
          console.error(error);
          //    throw error;
        }
      }
      this.$store.state.wsDialogVisible = false;
      this.$store.state.wsConnected = true;
      console.log("almost there");

      console.log(data);
      this.activeNotices = data.activeNotifications;
      this.$store.commit("updateField", { path: "activeNotices", value: this.activeNotices });
    });
  }

  urlws = "wss://pi.gigalot.systems:7778/api/ws";
  options = {};
  operationName = null;

  async getOnSiteNotificationsSocket() {
    let variables = { guid: this.$store.state.user.location.guid, user: this.$store.state.user.user.uid };
    this.graphQLSubscriber = Subscriber.graphQLReconnectingSubscriber(
      this.urlws,
      this.options,
      (error: any, subscribe: any) => {
        try {
          if (error) {
            console.log("error connecting to socket");
            this.$store.state.wsConnected = false;
            if (error.event.type !== "close") {
              this.$store.state.wsDialogVisible = true;
              console.error(error);
            }
            return;
          }
          if (!subscribe) {
            // Connection closed without an error.
            this.$store.state.wsConnected = false;
            return;
          }
          console.log("socket connected, subscribing..." + this.subscriptions + JSON.stringify(variables));
          this.$store.state.wsDialogVisible = false;
          this.$store.state.wsConnected = true;
          this.graphQLUnsubscribe = subscribe(this.subscriptions, variables, this.operationName, (error: any, data: any) => {
            if (error) {
              console.log("error subscribing");
              this.$store.state.wsConnected = false;
              if (error.event.type !== "close") {
                this.$store.state.wsDialogVisible = true;
                console.error(error);
              }
              return;
            }
            this.$store.state.wsDialogVisible = false;
            this.$store.state.wsConnected = true;
            console.log("almost there");

            console.log(data);
            this.activeNotices = data.activeNotifications;
            this.$store.commit("updateField", { path: "activeNotices", value: this.activeNotices });
          });
        } catch (err) {
          console.log(err);
          this.$store.state.wsConnected = false;
          //show offline maybe
          //this.$store.state.wsDialogVisible = true;
        }
      },
      15000,
      0,
      "graphql-ws"
    );
  }
}
